<template>
  <div class="hidden" />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useFueled } from '@/services/fueled'
interface Props {
  event: string | string[]
  data?: object
}
 
const { event, data } = defineProps<Props>()
onMounted(() => {
  const fueled = useFueled()
  const events = Array.from(event)
  events.forEach(event => {
    if (event === 'bundleProductViewed') {
      fueled.bundleProductViewed()
    } else {
      fueled.track(event, data)
    }
  })
})
</script>
